var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"clickable",on:{"click":function($event){return _vm.goToView(_vm.type)}}},[_c('td',[_c('vb-tooltip-slot',{attrs:{"content":_vm.getTooltipDescription(_vm.description, _vm.type)}},[_c('span',{staticClass:"column",class:_vm.child ? 'ml-5' : '',style:({
          'padding-left': _vm.paddingLeft,
          'font-size': _vm.fontSize,
        })},[_vm._v(" "+_vm._s(_vm.description)+" ")])])],1),_c('td',{staticClass:"text-right",style:({
      color: _vm.statusColor(_vm.type),
    })},[_c('span',{staticClass:"column"},[_vm._v(" "+_vm._s(_vm.value ? _vm.value : '-')+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }